import { CapsizedText as Text } from '@/components/text/text';
import { styled } from '@/stitches.config';

interface MetadataProps {
  title: string;
  subtitle: string;
}

export function MobileMetadata({ title, subtitle }: MetadataProps) {
  return (
    <MetadataContainer>
      <Text
        as="h3"
        size={3}
        css={{
          marginBottom: '1em',
        }}
      >
        {title}
      </Text>
      <Text
        as="p"
        size={2}
        css={{
          marginBottom: '0.25em',
        }}
      >
        {subtitle}
      </Text>
    </MetadataContainer>
  );
}

const MetadataContainer = styled('div', {
  position: 'relative',
  marginTop: '$6',
});
